<div class="ag-cell-editor fx-layout-row fx-justify-space-between fx-align-center">
  <mat-select #inputSelect [formControl]="control" class="ag-input-field-input"
              [placeholder]="control.value.label" (selectionChange)="stopEditing()">
    @if (optional) {
      <mat-option [value]="''">{{ 'LABEL.UNDEFINED' | translate }}</mat-option>
    }
    @for (entity of selectOptions; track entity.optionValue) {
      <mat-option [value]="entity">
        @if (params.fieldConfig?.customOptions?.translate) {
          {{ ('VALUE.' + params.fieldConfig.fieldCode + '_' + entity.label) | uppercase | translate }}
        } @else {
          {{ entity.label }}
        }
      </mat-option>
    }
  </mat-select>

  @if (control.invalid) {
    <div>
      <i class="mdi mdi-help-circle tooltip-icon" [matTooltip]="errorTooltip"></i>
    </div>
  }
</div>
